<template>
  <v-container fluid>
    <gh-invoke ref="invoke" v-model="data" module="mes.business.psm.batch.service" cls="BatchService" method="query"
      :args="args">
      <template v-slot="{args,data,loading}">
        <gh-data-table :table-config.sync="tableOptions" :loading="loading" :items="data[1]" :total-items="data[0]"
          :pagination.sync="pagination" table-id="5c99bb39785deb27d85ee009">
          <template #query_condition>
            <slot name="area_query"></slot>
          </template>
          <template #toolbar>
            <slot name="toolbar">
              <v-btn color="success" @click="query">查询</v-btn>
            </slot>
          </template>
          <template v-slot:[getCellSlotName(header)]="{props,header}" v-for="header in tableOptions.headers">
            <slot :name="getCellSlotName(header)" :props="props" :header="header"></slot>
          </template>
        </gh-data-table>
      </template>
    </gh-invoke>

  </v-container>
</template>

<style scoped>

</style>

<script>
  import BatchView from "./batchView.ts";
  export default BatchView;
</script>